import { CustomGridColumns } from '~/components/CustomDataGrid/protocols';

export const ibsCbs: CustomGridColumns[] = [
  {
    field: 'cod_ibs_cbs',
    headerName: 'Cód. IBS/CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'des_classif_trib_ibs_cbs',
    headerName: 'Classif. IBS/CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'val_red_social',
    headerName: 'Red. Social',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'val_bc_ibs_cbs',
    headerName: 'BC IBS/CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'per_aliq_cbs',
    headerName: 'Alíq. CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'per_red_cbs',
    headerName: 'Red. CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'val_cbs',
    headerName: 'Val. CBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'per_aliq_ibs_est',
    headerName: 'Alíq. IBS Est',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'val_ibs_est',
    headerName: 'Val. IBS Est.',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'per_aliq_ibs_mun',
    headerName: 'Alíq. IBS Mun.',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'per_red_ibs',
    headerName: 'Red. IBS',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
  {
    field: 'val_ibs_mun',
    headerName: 'Val. IBS Mun.',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
  },
];
